interface MetricsWarningToastProps {
  uri: string;
  firstName?: string;
}

const MetricsWarningToast = ({ uri, firstName }: MetricsWarningToastProps) => (
  <div className="S2">
    <div className="margin-b-12">Hey, {firstName || 'there'},</div>
    <div className="margin-b-12">Looks like you have a metrics API call that is not marked as metrics.</div>
    <div className="margin-b-12">
      Please add{' '}
      <code style={{ backgroundColor: 'yellow', color: 'red' }} className="margin-h-4 padding-h-2">
        isMetrics: true
      </code>{' '}
      to the API call parameters. This will ensure the call goes to the correct host.
    </div>
    <div>PATH:</div>
    <div>{uri}</div>
    <div className="margin-T-12">Thanks! :)</div>
    <div>P.S. This message will only show when running on localhost.</div>
  </div>
);

export default MetricsWarningToast;
